import { useForwardAccumulatorTileId } from '@/App/tiles/ForwardAccumulator/ProductProvider.tsx';
import { selectForwardAccumulatorScheduleTable } from '@/store/forwardAccumulator/selectors.ts';
import { useAppSelector } from '@/store/hooks.ts';

const Eki = ({ legId }: { legId: string }) => {
  const tileId = useForwardAccumulatorTileId();

  const step2 = useAppSelector((state) => selectForwardAccumulatorScheduleTable(state, tileId, legId)?.step2 ?? 0);

  return <span className="px-1">{step2}</span>;
};

export default Eki;
